import { render } from "./ResourceVersionTag.vue?vue&type=template&id=324ca942"
import script from "./ResourceVersionTag.vue?vue&type=script&lang=js"
export * from "./ResourceVersionTag.vue?vue&type=script&lang=js"
script.render = render

export default script